// Sesión de un sitio público en el navegador: el token por dirección del
// sitio en localStorage (el servidor solo guarda su hash). Sin localStorage
// (modo privado estricto) se guarda en memoria mientras dure la pestaña.

export interface StoredSiteSession {
  token: string;
  expiresAt: number;
}

const PREFIX = "heskala.site.";
const memory = new Map<string, StoredSiteSession>();

const keyOf = (slug: string) => `${PREFIX}${slug.trim().toLowerCase()}`;

export function readSiteSession(slug: string, now = Date.now()): StoredSiteSession | null {
  let stored: StoredSiteSession | null = memory.get(keyOf(slug)) ?? null;
  try {
    const raw = localStorage.getItem(keyOf(slug));
    if (raw) stored = JSON.parse(raw) as StoredSiteSession;
  } catch {
    // Sin localStorage o valor dañado: lo de memoria.
  }
  if (!stored || typeof stored.token !== "string" || !stored.token) return null;
  if (typeof stored.expiresAt === "number" && stored.expiresAt <= now) {
    clearSiteSession(slug);
    return null;
  }
  return stored;
}

export function saveSiteSession(slug: string, session: StoredSiteSession): void {
  memory.set(keyOf(slug), session);
  try {
    localStorage.setItem(keyOf(slug), JSON.stringify(session));
  } catch {
    // Solo en memoria.
  }
}

export function clearSiteSession(slug: string): void {
  memory.delete(keyOf(slug));
  try {
    localStorage.removeItem(keyOf(slug));
  } catch {
    // Nada que borrar.
  }
}
